<template>
<div>
{{changeContentType}}
<v-autocomplete v-if="init.procResults.active"
v-model="init.procResults.selected"
no-data-text = "Нет процессов для выбора"
:items="init.procResults.items"
hide-selected chips color="#4A76A8"
item-text="title"
item-value="process_id"
multiple
>

<template slot="label">
<span style="color:#FF8F18">{{init.procResultsLabel}}</span>
</template>




               <template
                 slot="item"
                 slot-scope="data"
               >
                 <template v-if="typeof data.item !== 'object'">
                   <v-list-tile-content v-text="data.title"></v-list-tile-content>
                 </template>
                 <template v-else>
                   <v-icon v-if="data.item.content_type == 'pages'"  medium color="#273C51">mdi-account-search</v-icon>
                   <v-icon v-else-if="data.item.content_type == 'groups'"  medium color="green">mdi-account-group</v-icon>
                   <v-icon v-else-if="data.item.content_type == 'topics'"  medium color="yellow">mdi-message-reply-text</v-icon>
                   <v-icon v-else-if="data.item.content_type == 'videos'"  medium color="red">mdi-youtube</v-icon>
                   <v-icon v-else-if="data.item.content_type == 'posts'"  medium color="pink">mdi-comment-multiple-outline</v-icon>
                   <v-list-tile-content>

                     <v-list-tile-title  >

                       <span    style="font-weight:bold; margin-left:15px; color:#4A76A8"> {{data.item.title}}  </span>
                     </v-list-tile-title>

                   </v-list-tile-content>
                   <v-btn @click.stop="getDescription()" small flat> <strong style="font-size:1.2em"> {{data.item.found_count}}  </strong></v-btn>
                 </template>
               </template>



               <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip

                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="removeSelectedResults(data.item)"
                >
                <v-icon v-if="data.item.content_type == 'pages'"  medium color="#273C51">mdi-account-search</v-icon>
                <v-icon v-else-if="data.item.content_type == 'groups'"  medium color="green">mdi-account-group</v-icon>
                <v-icon v-else-if="data.item.content_type == 'topics'"  medium color="yellow">mdi-message-reply-text</v-icon>
                <v-icon v-else-if="data.item.content_type == 'videos'"  medium color="red">mdi-youtube</v-icon>
                <v-icon v-else-if="data.item.content_type == 'posts'"  medium color="pink">mdi-comment-multiple-outline</v-icon>
                 <span    style="font-weight:bold; margin-left:15px; color:#4A76A8"> {{data.item.title}} {{ data.item.found_count }} </span>
                </v-chip>
              </template>

               </v-autocomplete>




<v-autocomplete v-if="init.procUpdates.active"
v-model="init.procUpdates.selected"
no-data-text = "Нет процессов для выбора"
:items="init.procUpdates.items"
hide-selected
chips
color="#4A76A8"
item-text="title"
item-value="process_id"
multiple
>
<template slot="label">
<span style="color:#FF8F18">{{init.procUpdatesLabel}}</span>
</template>



                          <template
                            slot="item"
                            slot-scope="data"
                          >
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-tile-content v-text="data.title"></v-list-tile-content>
                            </template>
                            <template v-else>
                              <v-icon v-if="data.item.content_type == 'pages'"  medium color="#273C51">mdi-account-search</v-icon>
                              <v-icon v-else-if="data.item.content_type == 'groups'"  medium color="green">mdi-account-group</v-icon>
                              <v-icon v-else-if="data.item.content_type == 'topics'"  medium color="yellow">mdi-message-reply-text</v-icon>
                              <v-icon v-else-if="data.item.content_type == 'videos'"  medium color="red">mdi-youtube</v-icon>
                              <v-icon v-else-if="data.item.content_type == 'posts'"  medium color="pink">mdi-comment-multiple-outline</v-icon>
                              <v-list-tile-content>

                                <v-list-tile-title  >
                                  <span    style="font-weight:bold; margin-left:15px; color:#4A76A8"> {{data.item.title}}  </span>
                                </v-list-tile-title>

                              </v-list-tile-content>

                            </template>
                          </template>



                          <template
                           slot="selection"
                           slot-scope="data"
                         >
                           <v-chip

                             :selected="data.selected"
                             close
                             class="chip--select-multi"
                             @input="removeSelectedUpdates(data.item)"
                           >
                           <v-icon v-if="data.item.content_type == 'pages'"  medium color="#273C51">mdi-account-search</v-icon>
                           <v-icon v-else-if="data.item.content_type == 'groups'"  medium color="green">mdi-account-group</v-icon>
                           <v-icon v-else-if="data.item.content_type == 'topics'"  medium color="yellow">mdi-message-reply-text</v-icon>
                           <v-icon v-else-if="data.item.content_type == 'videos'"  medium color="red">mdi-youtube</v-icon>
                           <v-icon v-else-if="data.item.content_type == 'posts'"  medium color="pink">mdi-comment-multiple-outline</v-icon>
                            <span    style="font-weight:bold; margin-left:15px; color:#4A76A8"> {{data.item.title}}  </span>
                           </v-chip>
                         </template>

                          </v-autocomplete>










  </div>
</template>

<script>

import axios from 'axios'
export default {
  props:['init','taskId' ],
  data () {
    return {

    }
  },
methods:{

getDescription(){
  alert(5454)
},



  removeSelectedResults (item) {
  const index = this.init.procResults.selected.indexOf(item.process_id)
  if (index >= 0) this.init.procResults.selected.splice(index, 1)
},

removeSelectedUpdates (item) {
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/unsub_proc.php', {method: 'POST',data: {proc: item.process_id,taskId: this.taskId}})
.then( response => {
const index = this.init.procUpdates.selected.indexOf(item.process_id)
if (index >= 0) this.init.procUpdates.selected.splice(index, 1)
})
},

},
computed:{

changeContentType (){
  if(this.init.contentType){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/get_processes.php', {
         method: 'POST',
         data: {contentType:this.init.contentType},
       }).then(response => {

    this.init.procResults.items = response.data
    this.init.procUpdates.items = response.data
    return  ''
       })
  }
}

},
mounted(){
   this.changeContentType
},


}
</script>
<style>


</style>
